import { render, staticRenderFns } from "./FavouriteFiltres.vue?vue&type=template&id=35b3a6e6&scoped=true&"
import script from "./FavouriteFiltres.vue?vue&type=script&lang=js&"
export * from "./FavouriteFiltres.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteFiltres.vue?vue&type=style&index=0&id=35b3a6e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3a6e6",
  null
  
)

export default component.exports